// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import AccordionSection, { AccordionSectionPresentationProps } from "@insite/mobius/AccordionSection";
import React, { FC, PropsWithChildren } from "react";

interface OwnProps {
    title?: string;
    expandByDefault?: boolean;
    type?: "widget" | "component";
}

export interface ToggleFiltersStyles {
    accordion?: AccordionSectionPresentationProps;
}

export const toggleFiltersStyles: ToggleFiltersStyles = {};

const styles = toggleFiltersStyles;

const ToggleFilters: FC<PropsWithChildren<OwnProps>> = ({
    title = translate("Filter Results"),
    expandByDefault = false,
    children,
    type = "component",
}) => {
    const [expanded, setExpanded] = React.useState(expandByDefault);

    return (
        <AccordionSection
            title={title}
            expanded={expanded}
            onTogglePanel={() => {
                setExpanded(!expanded);
            }}
            aria-label={translate("Toggle Filter")}
            {...styles.accordion}
        >
            <>
                {type === "component" && (
                    <StyledWrapper className="toggle-children-component">{children}</StyledWrapper>
                )}
                {type === "widget" && children}
            </>
        </AccordionSection>
    );
};

export default ToggleFilters;
